// extracted by mini-css-extract-plugin
export default {"backdrop":"Modal_backdrop__+ZT7Z","modal":"Modal_modal__ETc5o","slide-down":"Modal_slide-down__oIsy+"};